import { createContext, type MutableRefObject } from "react";

import type { TourDefinition } from "./types";

export type TourContextValue = {
  definition: TourDefinition;
  stepIds: string[];
  isRunning: boolean;
  fromCanonical: number | null;
  start: (fromCanonical?: number) => void;
  stop: () => void;
  lastVisitedKey: MutableRefObject<string | null>;
};

export const TourContext = createContext<TourContextValue | null>(null);
